/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { CreateManualEntryMutationRequest, CreateManualEntryMutationResponse, CreateManualEntryPathParams, CreateManualEntry400, CreateManualEntry401, CreateManualEntry403, CreateManualEntry404, CreateManualEntry409, CreateManualEntry500 } from "../../types/financialHubController/CreateManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getCreateManualEntryUrl(organizationId: CreateManualEntryPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/financial/transactions/` as const }
  return res
}

/**
 * @summary Create a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/}
 */
export async function createManualEntry(organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest, config: Partial<RequestConfig<CreateManualEntryMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, CreateManualEntryMutationRequest>({ method : "POST", url : getCreateManualEntryUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}